import styled, { css } from "styled-components"

import { Container } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, SpacingSize, TextSize, Transition } from "~/consts/style-mixins"
import { internalLink } from "~/services/helper"

interface Props {
  crumbs: { name: string; link: string }[]
}

const Breadcrumb = ({ crumbs }: Props) => {
  return (
    <StyledWrapper>
      <Container size="Large">
        <StyledList itemScope itemType="http://schema.org/BreadcrumbList">
          <StyledListItem itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <StyledLink
              itemType="https://schema.org/Thing"
              itemProp="item"
              href={`${process.env.INFRA_INTERN_URL}/long-internship`}
            >
              <span itemProp="name">インターンシップ・就職活動 Infra</span>
            </StyledLink>
            <meta itemProp="position" content="1" />
          </StyledListItem>
          {crumbs.map((crumb, i) => (
            <StyledListItem itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem" key={i}>
              <StyledLink itemType="https://schema.org/Thing" itemProp="item" href={crumb.link}>
                <span itemProp="name">{crumb.name}</span>
              </StyledLink>
              <meta itemProp="position" content={String(i + 1)} />
            </StyledListItem>
          ))}
        </StyledList>
      </Container>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  border-top: solid 1px ${Color.BorderGray};
  ${IsMobile(css`
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  `)}
`
const StyledList = styled.ul`
  display: flex;
  font-size: ${TextSize.XS}px;
  padding: ${SpacingSize.S}px 0;
`
const StyledListItem = styled.li`
  white-space: nowrap;
  &:not(:last-child) {
    &:after {
      color: ${Color.LightGray};
      content: "/";
      margin: 0 ${SpacingSize.XS}px;
    }
    a {
      color: ${Color.LightGray};
      ${Transition.Hover};
      &:hover {
        color: ${Color.Gray};
      }
    }
  }
  &:last-child {
    ${IsPC(css`
      overflow: hidden;
      text-overflow: ellipsis;
    `)}
    ${IsMobile(css`
      padding-right: 16px;
    `)}
  }
`
const StyledLink = styled.a`
  color: ${Color.Black};
  cursor: pointer;
  text-decoration: none;
`

export default Breadcrumb
